import sessionStore from './../stores/session';
import performanceStore from './../stores/performance';
import bgPerformanceStore from './../stores/bgPerformance';
import MuvikaService from './../services/muvika';

class TestService {

  failingTests = {};

  getFailing(cmd) {
    return this.failingTests[cmd];
  }

  addFailingTest(cmd, code, details, delay) {
    return this.failingTests[cmd] = {
      code: code,
      details: details,
      delay: delay
    };
  }

  removeFailingTest(cmd) {
    return this.failingTests[cmd] = undefined;
  }

  emptyPerformanceList() {
    let sessionToken = sessionStore.getState().sessionToken;

    let testQueue = {
      category: "karaoke",
      created: "2025-01-22T16:03:02",
      form: "list",
      id: 119333,
      info: "",
      items: [],
      name: "playqueue",
      type: "playqueue"
    };

    MuvikaService.setPlayList(sessionToken, testQueue)
      .then(function (res) {
        if (!res.data.error) {
          performanceStore.setState({ playQueue: testQueue });
        }
      })
      .catch(function () { });
  }

  setTestPerformanceList() {
    let sessionToken = sessionStore.getState().sessionToken;

    let testQueue = {
      category: "karaoke",
      created: "2025-01-22T16:03:02",
      form: "list",
      id: 119333,
      info: "",
      items: [
        {
          unique_id: "3sDX5p3O",
          created: "2025-01-28T09:25:53.443Z",
          played: null,
          pitch: 0,
          track: {
            artist: "Windows95man",
            audio_end: "179.78",
            audio_start: "6.33",
            crc: 1617888898,
            flags: "voc_avail",
            genre_ids: [
              19
            ],
            global_playcount: "0-100",
            is_favorite: 0,
            is_new: 0,
            kcode: "FS01770",
            label: "Finnhits Karaoke",
            label_id: 358,
            language: "English",
            language_id: 36,
            length: "00:03:03",
            license_released: "2024-02-16 16:52:49",
            media_class: "server",
            title: "No Rules!",
            track_id: 521493,
            type: 0,
            type_str: "karaoke",
            url_cover_image: "https://srv1.muvika.com//dl/image/FS/FS01770_vcoverimage_c649da1900366.jpg",
            url_thumb_image: "https://srv1.muvika.com//dl/image/FS/FS01770_vthumbimage_c649da1900366.jpg",
            year: 2024
          },
          profile: {
            created: "2025-01-22 14:34:06",
            email: "",
            gender: "male",
            id: 451217,
            name: "Selenium",
            pitch: 0,
            track_stats: []
          },
          isManual: null,
          position: 0,
          incoming: 0
        },
        {
          unique_id: "9Y5k7AZf",
          created: "2025-01-28T09:25:55.477Z",
          played: null,
          pitch: 0,
          track: {
            artist: "Tuomo Huttunen",
            audio_end: "0.00",
            audio_start: "0.16",
            crc: 1421907189,
            flags: "voc_avail",
            genre_ids: [
              5,
              15
            ],
            global_playcount: "0-100",
            is_favorite: 0,
            is_new: 0,
            kcode: "THK00001",
            label: "Tuomo Huttunen Karaoke",
            label_id: 485,
            language: "Finnish",
            language_id: 38,
            length: "00:03:07",
            license_released: "2024-02-16 12:29:51",
            media_class: "server",
            title: "Ilta koittaa ystäväin",
            track_id: 521665,
            type: 0,
            type_str: "karaoke",
            url_cover_image: "https://srv1.muvika.com//dl/image/THK/THK00001_vcoverimage_c145f5e39ceeb.jpg",
            url_thumb_image: "https://srv1.muvika.com//dl/image/THK/THK00001_vthumbimage_c145f5e39ceeb.jpg",
            year: 2023
          },
          profile: {
            created: "2025-01-22 14:34:06",
            email: "",
            gender: "male",
            id: 451217,
            name: "Selenium",
            pitch: 0,
            track_stats: []
          },
          isManual: null,
          position: 1,
          incoming: 183
        },
        {
          unique_id: "R6xzALVu",
          created: "2025-01-28T09:25:58.254Z",
          played: null,
          pitch: 0,
          track: {
            artist: "KUUMAA",
            audio_end: "161.96",
            audio_start: "5.51",
            crc: 2265882262,
            flags: "voc_avail",
            genre_ids: [
              19
            ],
            global_playcount: "0-100",
            is_favorite: 0,
            is_new: 0,
            kcode: "FS01760",
            label: "Finnhits Karaoke",
            label_id: 358,
            language: "Finnish",
            language_id: 38,
            length: "00:02:48",
            license_released: "2024-02-15 13:54:22",
            media_class: "server",
            title: "Satama",
            track_id: 519491,
            type: 0,
            type_str: "karaoke",
            url_cover_image: "https://srv1.muvika.com//dl/image/FS/FS01760_vcoverimage_c2265882262.jpg",
            url_thumb_image: "https://srv1.muvika.com//dl/image/FS/FS01760_vthumbimage_c2265882262.jpg",
            year: 2023
          },
          profile: {
            created: "2025-01-22 14:34:06",
            email: "",
            gender: "male",
            id: 451217,
            name: "Selenium",
            pitch: 0,
            track_stats: []
          },
          isManual: null,
          position: 2,
          incoming: 370
        }
      ],
      name: "playqueue",
      type: "playqueue"
    };

    MuvikaService.setPlayList(sessionToken, testQueue)
      .then(function (res) {
        if (!res.data.error) {
          performanceStore.setState({ playQueue: testQueue });
        }
      })
      .catch(function () { });
  }

  emptyMusicList() {
    let sessionToken = sessionStore.getState().sessionToken;

    let testQueue = {
      category: "music",
      created: "",
      criteria: {
        items: [
          [
            {
              key: "media_type",
              value: "music"
            }
          ]
        ],
        sort_by: [
          "random"
        ]
      },
      form: "criteria",
      id: 0,
      info: "",
      items: [],
      name: "",
      type: "playqueue"
    };

    MuvikaService.setMusicPlayList(sessionToken, testQueue)
      .then(function (res) {
        if (!res.data.error) {
          bgPerformanceStore.setState({ playQueue: testQueue });
        }
      })
      .catch(function () { });
  }

  setTestMusicList() {
    let sessionToken = sessionStore.getState().sessionToken;

    let testQueue = {
      category: "music",
      created: "",
      criteria: {
        items: [
          [
            {
              key: "media_type",
              value: "music"
            }
          ]
        ],
        sort_by: [
          "random"
        ]
      },
      form: "criteria",
      id: 0,
      info: "",
      items: [
        {
          unique_id: "sAFK04RO",
          created: "2025-01-29T12:52:34.748Z",
          played: null,
          pitch: 0,
          track: {
            artist: "Paula Koivuniemi",
            audio_end: "249.00",
            audio_start: "1.00",
            crc: 3602718785,
            genre_ids: [
              15
            ],
            global_playcount: "0-100",
            is_favorite: 0,
            is_new: 0,
            kcode: "KSF00272",
            label: "KSF music",
            label_id: 370,
            language: "Finnish",
            language_id: 38,
            length: "00:04:10",
            license_released: "2019-05-24 13:29:03",
            media_class: "server",
            title: "Aikuinen Nainen",
            track_id: 119248,
            type: 1,
            type_str: "music",
            year: 1982
          },
          profile: {
            created: "2025-01-22 14:34:06",
            email: "",
            gender: "male",
            id: 451217,
            name: "Selenium",
            pitch: 0,
            track_stats: []
          },
          flags: "",
          position: 0,
          incoming: 0
        },
        {
          unique_id: "R2dMlPTR",
          created: "2025-01-29T12:52:37.032Z",
          played: null,
          pitch: 0,
          track: {
            artist: "Paula Koivuniemi",
            audio_end: "240.00",
            audio_start: "1.00",
            crc: 621521627,
            genre_ids: [
              15
            ],
            global_playcount: "0-100",
            is_favorite: 0,
            is_new: 0,
            kcode: "LAK00318",
            label: "Laulavakoira music",
            label_id: 378,
            language: "Finnish",
            language_id: 38,
            length: "00:04:01",
            license_released: "2019-09-10 22:12:02",
            media_class: "server",
            title: "Aikuinen Nainen",
            track_id: 162870,
            type: 1,
            type_str: "music",
            year: 1982
          },
          profile: {
            created: "2025-01-22 14:34:06",
            email: "",
            gender: "male",
            id: 451217,
            name: "Selenium",
            pitch: 0,
            track_stats: []
          },
          flags: "",
          position: 1,
          incoming: 250
        },
        {
          unique_id: "D96juRw3",
          created: "2025-01-29T12:52:39.124Z",
          played: null,
          pitch: 0,
          track: {
            artist: "Paula Koivuniemi",
            audio_end: "215.00",
            audio_start: "1.00",
            crc: 535215408,
            genre_ids: [
              15
            ],
            global_playcount: "0-100",
            is_favorite: 0,
            is_new: 0,
            kcode: "LAK02306",
            label: "Laulavakoira music",
            label_id: 378,
            language: "Finnish",
            language_id: 38,
            length: "00:03:36",
            license_released: "2019-09-16 11:18:58",
            media_class: "server",
            title: "Nainen",
            track_id: 164460,
            type: 1,
            type_str: "music",
            year: 2009
          },
          profile: {
            created: "2025-01-22 14:34:06",
            email: "",
            gender: "male",
            id: 451217,
            name: "Selenium",
            pitch: 0,
            track_stats: []
          },
          flags: "",
          position: 2,
          incoming: 491
        }
      ],
      name: "",
      type: "playqueue"
    };

    MuvikaService.setMusicPlayList(sessionToken, testQueue)
      .then(function (res) {
        if (!res.data.error) {
          bgPerformanceStore.setState({ playQueue: testQueue });
        }
      })
      .catch(function () { });
  }


}

export default new TestService();